import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApplicantAuthGuardService } from './guards/applicant-auth-guard.service';
import { EmployeeAuthGuardService } from './guards/employee-auth-guard.service';
import { HomeComponent } from './pages/home/home.component';
import { RecoverPasswordComponent } from './pages/recover-password/recover-password.component';


const routes: Routes = [
  { path: 'login', loadChildren: './pages/login/login.module#LoginModule' },
  { path: 'login-professor', loadChildren: './pages/login/login.module#LoginModule' },
  { path: 'trocar-senha/:token', component: RecoverPasswordComponent },
  {
    path: 'applicant',
    component: HomeComponent,
    canActivate: [ApplicantAuthGuardService],
    children: [
      { path: '', loadChildren: './pages/applicant/applicant.module#ApplicantModule' },
    ]
  },
  {
    path: 'employee',
    component: HomeComponent,
    canActivate: [EmployeeAuthGuardService],
    children: [
      { path: '', loadChildren: './pages/employee/employee.module#EmployeeModule' },
    ]
  },
  {
    path: '**',
    redirectTo: 'login',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
